var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1949.9px",
    height: "1994.7px",
    viewBox: "0 0 1949.9 1994.7",
    style: {
      enableBackground: "new 0 0 1949.9 1994.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.4;fill:#C9C9C9;enable-background:new    ;}\r\n\t.st1{fill:#F9C0C0;}\r\n\t.st2{opacity:0.4;fill:#F4F4F4;enable-background:new    ;}\r\n\t.st3{opacity:0.3;fill:#999999;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "831.1,1325.6 853.9,1308.4 1098.7,1308.4 1120.3,1325.5 1899,916.4 975.7,140.1 50.9,916.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1706.2,49.4H243.7c-43.6,0-78.9,35.3-78.9,78.9v1675.4c0,43.6,35.3,78.9,78.9,78.9h1462.5 c43.6,0,78.9-35.3,78.9-78.9V128.3C1785.2,84.7,1749.8,49.4,1706.2,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1899,916.4v1024.7H50.9V916.4l780.2,409.2l22.8-17.2h244.8l20.2,15.9l1.4,1.1L1899,916.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.4,915.6l106.4-89.3v-5.5L50.9,916.4h9L58.4,915.6z M54.8,913.7L54.8,913.7L54.8,913.7L54.8,913.7z  M1120.8,1320.5l-20.7-16.2H852.5l-21.8,16.5L59.9,916.4h-9v1024.7H1899V916.4h-9L1120.8,1320.5z M55.1,923.3l768.4,403 L55.1,1932.5V923.3z M63,1936.9l770.7-608l21.7-16.3h241.9l19.1,15.1l0,0l3.5,2.8l0,0L1887,1937L63,1936.9L63,1936.9z  M1894.8,1932.5L1128,1326.2l766.8-402.8V1932.5z M1891.5,915.6l-106.4-89.4v-5.5l113.8,95.7h-9L1891.5,915.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.b4876bb74f51a67da74acf2cc2731063.svg";
export { ForwardRef as ReactComponent };